import React, { useRef, useState } from 'react'
import Translate from "../../../../../../../components/Translate";
import colors from "../../../../../../../utils/Colors";
import MessageEditor from "../components/MessageEditor";
import SilverButton from "../../../../../../../components-new/buttons/SilverButton";
import PlusIcon from "../../../../../../../assets/icons/PlusIcon";
import GripVerticalIcon from "../../../../../../../assets/icons/GripVerticalIcon";

const Messages = ({ messages, setMessages }) => {
    const containerRef = useRef(null);
    const [dragIndex, setDragIndex] = useState(null);
    const [dragY, setDragY] = useState(0);
    const [startY, setStartY] = useState(0);

    const handleMouseDown = (e, index) => {
        setDragIndex(index);
        setStartY(e.clientY);
        e.preventDefault();
    };

    const handleMouseMove = (e) => {
        if (dragIndex === null) return;
        const delta = e.clientY - startY;
        setDragY(delta);
    };

    const handleMouseUp = () => {
        if (dragIndex === null) return;

        const delta = dragY;
        let newMessages = [...messages];

        if (Math.abs(delta) > 50) {
            const direction = delta < 0 ? -1 : 1;
            const targetIndex = dragIndex + direction;

            if (targetIndex >= 0 && targetIndex < messages.length) {

                const temp = newMessages[dragIndex];
                newMessages[dragIndex] = newMessages[targetIndex];
                newMessages[targetIndex] = temp;
                setMessages(newMessages);
            }
        }

        setDragIndex(null);
        setDragY(0);
        setStartY(0);
    };

    React.useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    });

    return (
        <div className="control-section border-bottom messages-section" ref={containerRef}>
            <h2 className="heading" style={{fontSize: '14px',color: colors.silverBlue, fontWeight: 'normal'}}>
                <Translate text="pleaseFillMessage"/>
            </h2>

            <ul
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    padding: '6px',
                    margin: '16px -6px 4px -6px',
                    overflowY: 'auto',
                    overflowX: 'visible',
                    maxHeight: '400px',
                    position: 'relative',
                }}
            >
                {messages.length > 0 ? (
                    messages.map((message, index) => {
                        const isDragging = dragIndex === index;
                        const transformY = isDragging ? `translateY(${dragY}px)` : 'none';
                        const zIndex = isDragging ? 10 : 1;
                        const transition = isDragging ? 'none' : 'transform 0.2s ease';

                        return (
                            <div
                                key={message + index}
                                ref={el => (el && isDragging ? (containerRef.current = el) : null)}
                                style={{
                                    display: 'flex',
                                    gap: '8px',
                                    alignItems: 'center',
                                    transform: transformY,
                                    zIndex,
                                    transition,
                                }}

                            >
                                {messages.length > 1 && <GripVerticalIcon
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    onMouseDown={(e) => handleMouseDown(e, index)}
                                    style={{cursor: 'grab', color: colors.silverBlueExtraLite, flexShrink: 0}}
                                    width={18}
                                />}

                                <MessageEditor
                                    text={message}
                                    onDelete={() => {
                                        setMessages(messages.filter((_, i) => i !== index));
                                    }}
                                    onSave={(val) => {
                                        setMessages(messages.map((m, i) => (i === index ? val : m)));
                                    }}
                                    defaultEditable={message === ''}
                                    style={{flex: '1 1 0', minWidth: 0}}
                                    textLimit={1024}
                                />
                            </div>
                        );
                    })
                ) : (
                    <span
                        style={{
                            margin: '20px 0',
                            color: colors.silverBlueLite,
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                        }}
                    >
                        <Translate text="noMessages" />
                    </span>
                )}
            </ul>

            <SilverButton
                onClick={() => {
                    if (messages[messages.length - 1] !== '') setMessages([...messages, '']);
                }}
                styles={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    color: colors.silverDark,
                    fontSize: '14px',
                }}
            >
                <PlusIcon style={{color: colors.silverDark}} stroke="currentColor" width={18} height={18} />
                <Translate text="addBotMessage" />
            </SilverButton>
        </div>
    );
};

export default Messages;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/NodeEditor/partials/Messages.jsx